import { graphql, useStaticQuery } from "gatsby"

export const useAwardsReviewsData = () => {
  const data = useStaticQuery(graphql`
    query AwardsReviews {
      sanityAwardsReview {
        id
        awards {
          asset {
            url
            gatsbyImageData
          }
        }
        showReviews
        reviews {
          name
          review
          title
        }
        rating
        numberReviews
        ratingBgimage {
          asset {
            gatsbyImageData
          }
        }
      }
    }
  `)

  return data
}
